import React from 'react';
import { AtlassianIcon, AtlassianLogo } from '@atlaskit/logo';
import { AtlassianNavigation, ProductHome } from '@atlaskit/atlassian-navigation';
import { B400, B200 } from '@atlaskit/theme/colors';
import { routePaths } from '@css-xp/ppc-constants';
import { AppSwitcher, ProfileButton, PartnerCentralProductHome } from '@css-xp/ppc-navigation';
// @ts-ignore:next-line
import sandTimerSvg from './sand-timer.svg';
import './coming-soon-page.scss';

const Logo = () => <AtlassianLogo textColor={B400} iconColor={B200} />;
const redirectionLink = 'https://atlassianpartners.atlassian.net/wiki/x/rILLEg';

export const ComingSoonPage = () => {
  return (
    <div className="coming-soon-page">
      <AtlassianNavigation
        label="site"
        renderProductHome={() => <PartnerCentralProductHome redirectToUrl={routePaths.accessPending} />}
        renderAppSwitcher={() => <AppSwitcher />}
        renderProfile={ProfileButton}
        primaryItems={[]}
      />
      <div className="coming-soon-page-body">
        {/* @ts-ignore:next-line */}
        <img src={sandTimerSvg} />
        <div className="coming-soon-content-container">
          <ProductHome icon={AtlassianIcon} logo={Logo} />
          <h1>Coming Soon</h1>
          <p>
            Partner Purchasing Center - a one-stop-shop for managing the billing needs of
            <span className="line-break">your customers.</span>
            <br />
          </p>
          <p>
            For help in the meantime with invoices, subscriptions, or procuring Atlas and
            <span className="line-break">
              Jira Product Discovery,{' '}
              <a href={redirectionLink} target="_blank" rel="noopener noreferrer">
                reach out to our Advocate teams.
              </a>{' '}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
